import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function ColectieFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: 'Trebuie să am experiență anterioară în Theta Healing® sau dezvoltare personală?',
    a: 'Nu. Cursurile sunt gândite pas cu pas, de la zero. Începi cu fundamentele și avansezi progresiv. Singura condiție este deschiderea de a învăța și de a practica.'
  }, {
    q: 'Cât durează până văd primele rezultate?',
    a: 'Depinde de implicarea ta. Unii participanți simt schimbări încă din prima săptămână de practică — mai multă liniște interioară și claritate mentală. Transformările mai profunde apar de obicei în primele 2-3 luni de aplicare constantă.'
  }, {
    q: 'Pot face cursurile în ritmul meu sau trebuie să urmez un program fix?',
    a: 'Cursurile sunt înregistrate și ai acces pe viață, deci le parcurgi în ritmul tău. Întâlnirile săptămânale de grup au un program fix, dar sunt suplimentare și te ajută să aprofundezi ce ai învățat.'
  }, {
    q: 'Care este diferența între Programul Standard și Premium?',
    a: 'Programul Standard include cele 6 cursuri și 24 de întâlniri de grup. Programul Premium adaugă 6 sesiuni individuale 1:1, 6 ședințe de terapie Theta Healing® și un retreat de weekend. E pentru cine vrea un traseu personalizat și lucru profund pe blocaje specifice.'
  }, {
    q: 'Pot cumpăra un singur curs fără să iau tot pachetul?',
    a: 'Da. Fiecare curs se poate cumpăra separat la 500 lei. Totuși, pachetul complet este recomandat pentru că cele 6 cursuri sunt gândite ca un proces progresiv. Fiecare curs construiește pe fundamentul celui anterior.'
  }, {
    q: 'Ce se întâmplă dacă nu văd rezultate?',
    a: 'Dacă parcurgi programul complet și nu vezi rezultate, primești acces suplimentar gratuit în Academie pentru încă 6 luni, ca să ai timp să aprofundezi și să practici mai mult.'
  }, {
    q: 'Funcționează și pentru bărbați sau este doar pentru femei?',
    a: 'Programul este deschis tuturor. Deși majoritatea participanților sunt femei, conținutul este universal. Lucrul cu subconștientul, credințele limitative și abundența se aplică pentru oricine.'
  }];
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-411">
      <div className="max-w-4xl mx-auto px-6" data-id="element-412">
        <SectionHeading title="Întrebări Frecvente" data-id="element-413" />

        <div className="space-y-4 mb-16" data-id="element-414">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} className="border border-brand-text/10 rounded-2xl overflow-hidden bg-brand-cream/50" data-id="element-415">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" aria-expanded={openIndex === index} data-id="element-416">
                <span className="font-bold text-lg text-brand-text pr-8" data-id="element-417">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-gold flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-418" />
              </button>
              <AnimatePresence data-id="element-419">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-420">
                    <div className="px-6 pb-5 text-brand-textSec leading-relaxed" data-id="element-421">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-422">
          <CTAButton data-id="element-423" />
        </motion.div>
      </div>
    </section>;
}